import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { COLOR_BG, COLOR_PRIMARY, COLOR_TEXT_MUTED } from "../../styles/colors";
import { trackEvent, GA_EVENTS } from "../../utils/analytics";
import { ProblemLibrary } from "./ProblemLibrary";

export const ProblemLibraryPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    trackEvent(GA_EVENTS.PAGE_VIEW_PROBLEMS);
  }, []);

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: COLOR_BG, py: 4 }}>
      <Container maxWidth="md">
        <Button startIcon={<ArrowBackIcon />} onClick={() => navigate("/")} sx={{ textTransform: "none", mb: 2 }}>
          Home
        </Button>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
          <img src="/logo100.png" alt="System Design Playground Logo" width={40} height={40} />
          <Typography variant="h4" component="h1" sx={{ fontWeight: 800, color: COLOR_PRIMARY }}>
            Problem Library
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ color: COLOR_TEXT_MUTED, mb: 3 }}>
          Pick a classic system design interview problem. We'll set up its traffic so you can focus on the design.
        </Typography>
        <ProblemLibrary onStarted={() => navigate("/app")} />
      </Container>
    </Box>
  );
};
